import en from './en';
import ru from './ru';

const resources = { ru, en };
export default resources;
